function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useContext } from 'react';
import { ScreenSize } from '../../theme/screen-sizes';
import { ScreenSizeContext } from './screen-size-context';
/**
 * Determines the current size of the viewport. Can be
 *   xsmall (mobile), small (bigger mobile), medium (small laptop),
 *   or large (most desktops)
 *
 * See {@link ScreenSize} for breakpoints.
 */

export var useScreenSize = function useScreenSize() {
  return useContext(ScreenSizeContext);
};
/**
 * Get the closest option for the given screenSize.
 *   If no exact match, attempts to find the closest
 *   smaller match. If still no match, attempts to find
 *   the closets larger match. If still no match, returns
 *   null.
 *
 * @param screenSize - Current screen size
 * @param options - Options to choose from
 */

export var selectForScreenSize = function selectForScreenSize(screenSize, options) {
  var option; // Backwards search first.

  for (var key = screenSize; key >= ScreenSize.xsmall; key--) {
    option = options[key];

    if (option !== undefined) {
      return option;
    }
  } // Forwards search first.


  for (var _key = screenSize + 1; _key <= ScreenSize.large; _key++) {
    option = options[_key];

    if (option !== undefined) {
      return option;
    }
  }

  return null;
};
/**
 * Get the closest option for the given screenSize
 *   driven by a literal/value keyset.
 *
 * @param screenSize - Current screen size
 * @param options - Options to choose from
 */

export var selectForNamedScreenSize = function selectForNamedScreenSize(screenSize, options) {
  // Convert the map keyed on literals to a map
  //   keyed on enum values.
  var convertedOptions = Object.entries(options).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (value) {
      var newKey = ScreenSize[key];
      acc[newKey] = value;
    }

    return acc;
  }, {});
  return selectForScreenSize(screenSize, convertedOptions);
};